import { getProduct } from '../config.js'
import commonMenu from './common'
import club1Menu from './club1'
import course1Menu from './course1'

export const getMenu = () => {
  const product = getProduct()
  const productMenu = product === 'course1' ? course1Menu : club1Menu
  return [...commonMenu, ...productMenu]
}